import React from 'react';
import {useWatch} from "react-hook-form";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {financial} from "v4/utils";

export default function SectionSubTotal({name}) {
    const {t} = usePolTranslation();
    const quoteLines = useWatch({name: 'quoteLines'});

    return (
        <div className="quotes-products__tbody__section__total">
            <span>{t('subtotal_with_discount')} {name.split('|')[1]} :</span>
            <span>{financial(getSubTotal(quoteLines ?? [], name))}</span>
        </div>
    );
}

function getSubTotal(values, sectionNameFilter) {
    return values
        .filter(({isOptional, sectionName}) => !isOptional && sectionName === sectionNameFilter)
        .reduce((acc, {unitPriceExclVat, quantity, discountValue, discountType}) => {
            const discountByUnitIfPercentage = discountType === 'percentage' ? parseFloat((unitPriceExclVat * (discountValue / 100)).toFixed(2)) : 0;

            if (discountType === 'amount') {
                acc += (unitPriceExclVat * quantity) - discountValue;
            } else {
                acc += ((unitPriceExclVat - discountByUnitIfPercentage) * quantity);
            }

            return acc;
        }, 0)
}
